
export default {
  data() {
    return {
      forms: [],
      formId: 0,
      formData: {},
      pageData: null,
      selectedForms: [],
      activeContactIndex: 0,
      selectedFiles: [],
      selectedFile: null,
      options: [
        {
          name: "logo",
          label: "Logo",
          type: "image",
          size: "50x50",
        },
        {
          name: "text",
          label: "Tekst",
          type: "text",
        },
      ],
    };
  },
  watch: {
    $isInEditMode(v) {
      this.getAllForms();
    },
  },
  mounted() {
    this.getPageData();

    if (this.$isInEditMode) {
      this.getAllForms();
    }
  },
  methods: {
    returnConsentText(index) {
      switch (index) {
        case 0:
          return "tvrtke Gauss";
          break;
        case 1:
          return "Gimnazije Gaudeamus";
          break;
        case 2:
          return "tvrtke VRGR8";
          break;
        default:
          return "Privola";
      }
    },

    setActiveContact(index) {
      this.activeContactIndex = index;
      this.formData = {}; // Reset form data when switching forms

      const element = document.getElementById("forms");
      if (element) {
        element.scrollIntoView();
      }
    },

    getPageData() {
      if (
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.pageData
      ) {
        this.pageData = this.$parent.$parent.pageData;

        if (
          this.pageData &&
          this.pageData.components &&
          this.pageData.components.length
        ) {
          this.pageData.components.forEach((data) => {
            if (data && data.linkMeta && data.linkMeta.formId) {
              this.formId = parseInt(
                data.linkMeta.formId.replace(/(<([^>]+)>)/gi, "")
              );
            }
            this.getForms();
          });
        }
      }
    },

    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getForms() {
      try {
        const data1 = await this.$axios.get("/api/v1/cms/form/get/" + this.formId);
        if (data1 && data1.data && data1.data.data) {
          this.selectedForms.push(data1.data.data);
          // Initialize form data structure
          this.initializeFormData(data1.data.data.fields);
        }
      } catch (e) {
        console.error('Error fetching form:', e);
      }
    },

    initializeFormData(fields) {
      fields.forEach(field => {
        // Initialize based on field type
        switch (field.type) {
          case 'checkbox':
            this.formData[field.key] = field.options ?
              field.options.reduce((acc, option) => ({ ...acc, [option.key]: false }), {}) :
              false;
            break;
          case 'file':
            this.formData[field.key] = null;
            break;
          case 'multipleMedia':
            this.formData[field.key] = [];
            break;
          case 'multiselect':
            this.formData[field.key] = [];
            break;
          case 'radio':
            this.formData[field.key] = null;
            break;
          default:
            this.formData[field.key] = '';
        }
      });
    },

    handleCheckboxChange(fieldKey, optionKey, value) {
      if (!this.formData[fieldKey]) {
        this.formData[fieldKey] = {};
      }
      this.formData[fieldKey][optionKey] = value;

      // Convert the object of boolean values to an array of selected keys
      const selectedOptions = Object.entries(this.formData[fieldKey])
        .filter(([_, value]) => value)
        .map(([key]) => key);

      // Get the form reference from the current active form
      const formRef = this.$refs[`contact${this.selectedForms[this.activeContactIndex].id}`];
      if (formRef && formRef[0]) {
        this.setFormInputs(formRef[0].form, { key: fieldKey, type: 'checkbox' });
      }
    },

    setFormInputs(form, field) {
      if (!form) return;

      // Handle file uploads
      if (field.type === 'file') {
        form[field.key] = this.formData[field.key];
        return;
      }

      // Handle multiple file uploads
      if (field.type === 'multipleMedia') {
        form[field.key] = Array.isArray(this.formData[field.key]) ? this.formData[field.key] : [];
        return;
      }

      // Handle checkbox with options
      if (field.type === 'checkbox' && field.options) {
        console.log(this.formData[field.key], field.options);
        const selectedOptions = Object.entries(this.formData[field.key])
          .filter(([_, value]) => value)
          .map(([key]) => key);
        form[field.key] = selectedOptions;
        return;
      }

      // Handle other input types
      form[field.key] = this.formData[field.key] || null;
    },

    returnAllowedExts(field) {
      if (!field) return;

      let allowedExts;
      let index;

      if (field.validation && field.validation.length) {
        if (field.validation.length > 1) {
          index = 1;
        } else {
          index = 0;
        }

        if (typeof field.validation[index] === "string") {
          allowedExts = field.validation[index].replace("allowedExts:", "");
          allowedExts = allowedExts.replace("[", "");
          allowedExts = allowedExts.replace("]", "");
          allowedExts = allowedExts
            .split(" ")
            .map((s) => "." + s)
            .join(" ");
        }
      }

      return allowedExts;
    },

    setFiles(form, field, event) {
      this.selectedFiles = [];

      if (event && event.length) {
        event.forEach((e, index) => {
          if (this.validateFilesSize(e)) {
            this.selectedFiles.push(e);
          } else {
          }
        });

        form[field.key] = event;
      } else {
        form[field.key] = null;
      }
    },

    fileUpload(event, form, field) {
      this.selectedFiles = [];
      form[field.key] = null;

      if (!event.target.files) {
        return;
      }

      const files = Array.from(event.target.files);

      if (files && files.length && this.validateFilesSize(files)) {
        files.forEach((file, index) => {
          this.selectedFiles.push(file.name);
        });
      }
    },

    validateFilesSize(files) {

      if (!files) {
        return;
      }

      var filesSize = 0;

      if (files && files.length) {
        files.forEach((file, index) => {
          filesSize += file.size;
        });
      }

      if (filesSize / 1024 ** 2 > 10) {
        this.$toast.error(this.$t("toast.fileTooBig"));
        return false;
      } else {
        return true;
      }
    },

    deleteFile(file, form, field) {

      if (!file) {
        return;
      }

      form[field.key] = form[field.key].filter(function (item) {
        return item !== file;
      });

      this.selectedFiles = this.selectedFiles.filter(function (item) {
        return item !== file;
      });

    },

    setSingleFile(form, field, event) {
      if (event && event.length) {
        const file = event[0];
        if (this.validateFilesSize(file)) {
          this.selectedFile = file;
          form[field.key] = file;
        } else {
          this.selectedFile = null;
          form[field.key] = null;
        }
      } else {
        this.selectedFile = null;
        form[field.key] = null;
      }
    },

    singleFileUpload(event, form, field) {
      this.selectedFile = null;
      form[field.key] = null;

      if (!event.target.files) {
        return;
      }

      const file = event.target.files[0];

      if (file && this.validateFilesSize(file)) {
        this.selectedFile = file;
      }
    },

    deleteSingleFile(form, field) {
      this.selectedFile = null;
      form[field.key] = null;
    },
  },
};
